module.exports = __webpack_public_path__ + "static/assets/51d064ccbf7daeb159a16fb735dd0a69.gif";